import Vue from 'vue'
import App from './App.vue'
import router from './router';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/app.css"
import vuetify from './plugins/vuetify';
import 'animate.css';
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
